import { YOO_FINDS_CDN } from "@/common";

export const ABOUT_US_COOPERATION = `${YOO_FINDS_CDN}/pc/about_us/cooperation.png`;

export const ABOUT_US_WHAT_APP_QR_CODE = `${YOO_FINDS_CDN}/pc/about_us/whatsapp-QRcode.png`;

export const ABOUT_US_CALL = `${YOO_FINDS_CDN}/pc/about_us/call-icon.svg`;

export const ABOUT_US_JOIN_DISCORD = `${YOO_FINDS_CDN}/pc/about_us/join-discord-btn.png`;
export const JOIN_DISCORD_URL = "https://discord.gg/DaVzgFRm";

export const ABOUT_US_TT_INTRO_LIST = [
  `${YOO_FINDS_CDN}/pc/about_us/tt-intro1-v2.png`,
  `${YOO_FINDS_CDN}/pc/about_us/tt-intro2-v2.png`,
  `${YOO_FINDS_CDN}/pc/about_us/tt-intro3-v2.png`,
];

export const ABOUT_US_HOW_WORK_LIST = [
  {
    iconSrc: `${YOO_FINDS_CDN}/pc/about_us/GMV-icon.svg`,
    title: "$964.1k",
    describe: "Shop GMV",
  },
  {
    iconSrc: `${YOO_FINDS_CDN}/pc/about_us/videos-icon.svg`,
    title: "286",
    describe: "Videos made",
  },
  {
    iconSrc: `${YOO_FINDS_CDN}/pc/about_us/tt-views.svg`,
    title: "6.7k",
    describe: "TikTok views",
  },
];

export const ABOUT_US_HOW_WORK_STEPS = [
  {
    imageSrc: `${YOO_FINDS_CDN}/pc/about_us/step1.png`,
    title: "01",
    content: "Set up your free sample",
  },
  {
    imageSrc: `${YOO_FINDS_CDN}/pc/about_us/step2.png`,
    title: "02",
    content: "Post videos",
  },
  {
    imageSrc: `${YOO_FINDS_CDN}/pc/about_us/step3.png`,
    title: "03",
    content: "Product goes viral",
  },
];

export const ABOUT_US_KOL_LIST = [
  `${YOO_FINDS_CDN}/pc/about_us/KOL1.png`,
  `${YOO_FINDS_CDN}/pc/about_us/KOL2.png`,
  `${YOO_FINDS_CDN}/pc/about_us/KOL3.png`,
  `${YOO_FINDS_CDN}/pc/about_us/KOL4.png`,
];

export const INS_URL = "https://www.instagram.com/yoo_finds/";

export const ABOUT_US_FOOTER_ICON_LIST = [
  {
    iconSrc: `${YOO_FINDS_CDN}/pc/about_us/ins-icon.svg`,
    goUrl: INS_URL,
    alt: "ins",
  },
  // { iconSrc: '${YOO_FINDS_CDN}/pc/about_us/facebook-icon.svg' },
  // { iconSrc: '${YOO_FINDS_CDN}/pc/about_us/tt-icon.svg' },
];

export const PRIVACY_POLICY_URL = "https://www.yoofinds.com/doc/privacy.html";

export const ABOUT_US_INTRO = `${YOO_FINDS_CDN}/pc/about_us/yf-aboutus-intro.png`;
